import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { ReturnsFlagKey } from "@redotech/feature-flags-keys-returns/keys";
import { useContext } from "react";
import { useTeamFeatureFlag } from "../use-team-feature-flag";
import { UserContext } from "../user";
import { resolveReturnsSettingsExperience } from "./returns-settings-experience";

export interface ReturnsSettingsExperience {
  pending: boolean;
  useNewUi: boolean;
}

export function useReturnsSettingsExperience(): ReturnsSettingsExperience {
  const user = useContext(UserContext);
  const isRedoUser = isRedoEmailAddress(user?.email);
  const rollout = useTeamFeatureFlag(
    ReturnsFlagKey.CONSOLIDATED_RETURNS_SETTINGS,
    { forceEnabledForRedoUsers: false },
  );
  const requiredForRedoUsers = useTeamFeatureFlag(
    ReturnsFlagKey.CONSOLIDATED_RETURNS_SETTINGS_REQUIRED_FOR_REDO_USERS,
    { forceEnabledForRedoUsers: false },
  );

  const { useNewUi } = resolveReturnsSettingsExperience({
    isRedoUser,
    teamInRollout: rollout.enabled,
    requiredForRedoUsers: requiredForRedoUsers.enabled,
  });

  return {
    pending: rollout.pending || (isRedoUser && requiredForRedoUsers.pending),
    useNewUi,
  };
}
